const KEY = "bb_parent_unlock";

export function getParentUnlock() {
  const t = sessionStorage.getItem(KEY);
  if (!t) return null;
  try {
    const { exp } = JSON.parse(atob(t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    if (exp * 1000 > Date.now()) return t;
  } catch { /* invalid token */ }
  sessionStorage.removeItem(KEY);
  return null;
}

export const setParentUnlock = (t) => t && sessionStorage.setItem(KEY, t);
export const clearParentUnlock = () => sessionStorage.removeItem(KEY);
